<template lang="pug">
  f7-block(class="multiline-text-view")
    p(v-html="multilineText")
</template>

<style lang="scss">
.multiline-text-view {
  padding: 0;
  margin: 0;

  p {
    @extend %body-text;
  }

  .browser-link {
    color: #0052cc !important;
  }
}
</style>

<script>
export default {
  props: {
    text: { type: String, default: '' },
  },
  computed: {
    multilineText() {
      return this.text.replace(/\r?\n/g, '<br>')
    },
  },
}
</script>
